import { render, staticRenderFns } from "./StepConfirmarConsulta.vue?vue&type=template&id=c4939816"
import script from "./StepConfirmarConsulta.vue?vue&type=script&lang=js"
export * from "./StepConfirmarConsulta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports